module.exports = __webpack_public_path__ + "img/article-3-1.0aec8e11.jpg";